/** 앱에서 웹의 onAppForeground 콜백 존재 여부를 체크하지 않으므로, 전역 기본 콜백 등록 */
export const defaultBridgeCallback = () => {};
